var render, staticRenderFns
import script from "./vRecord.vue?vue&type=script&lang=js&"
export * from "./vRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf465e4",
  null
  
)

export default component.exports